import { parseISO, format } from "date-fns";

export const getFormattedDate = (date, formatStr) => (date ? format(parseISO(date), formatStr) : "--");



export const roundToTwoDecimalPlaces=(num)=> {
    return parseFloat(num.toFixed(2));
  }
  
  export function toTwoDecimalPlaces(value) {
    return parseFloat(value).toFixed(2);
  }